import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ApiError } from '../../../common/utils/api-error';
export var addPath = function addPath(baseUrl, path) {
  if (path === '') {
    // return base url without trailing slash
    return baseUrl;
  }
  var urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : "".concat(baseUrl, "/");
  var pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
  var url = [urlWithTrailingSlash, pathWithoutLeadingSlash].join('');
  return url;
};
export var getTraceIdFromResponse = function getTraceIdFromResponse(response) {
  var _ref, _ref2, _response$headers$get, _response$headers, _response$headers2, _response$headers3;
  return (_ref = (_ref2 = (_response$headers$get = response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response === null || response === void 0 || (_response$headers2 = response.headers) === null || _response$headers2 === void 0 ? void 0 : _response$headers2.get('atl-traceid')) !== null && _ref2 !== void 0 ? _ref2 : response === null || response === void 0 || (_response$headers3 = response.headers) === null || _response$headers3 === void 0 ? void 0 : _response$headers3.get('x-b3-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
};
var processErrorResponse = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var response, errorCode, outputErrorMessage, responseText, rawErrorMessage, errorBodyJson, error_code, error_message, message_template, errors, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          response = _ref3.response;
          _context.next = 3;
          return response.text();
        case 3:
          responseText = _context.sent;
          try {
            errorBodyJson = JSON.parse(responseText);
            error_code = errorBodyJson.error_code, error_message = errorBodyJson.error_message, message_template = errorBodyJson.message_template, errors = errorBodyJson.errors, errorMessage = errorBodyJson.errorMessage;
            rawErrorMessage = errorMessage !== null && errorMessage !== void 0 ? errorMessage : error_message;
            if (errors !== null && errors !== void 0 && errors.length) {
              // Use a single error code for now
              errorCode = errors[0];
            } else if (error_code) {
              errorCode = error_code;
            } else {
              errorCode = message_template;
            }
            if (!errorCode || !rawErrorMessage) {
              outputErrorMessage = responseText;
            } else {
              outputErrorMessage = "".concat(errorCode, " - ").concat(rawErrorMessage);
            }
          } catch (err) {
            outputErrorMessage = responseText;
          }
          throw new ApiError("[Code ".concat(response.status, "] ").concat(outputErrorMessage), {
            errorCode: errorCode,
            statusCode: response.status,
            rawErrorMessage: rawErrorMessage,
            traceId: getTraceIdFromResponse(response)
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function processErrorResponse(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export var processResponse = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          response = _ref5.response;
          if (!(!response.ok || response.status >= 400)) {
            _context2.next = 4;
            break;
          }
          _context2.next = 4;
          return processErrorResponse({
            response: response
          });
        case 4:
          return _context2.abrupt("return", response);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function processResponse(_x2) {
    return _ref6.apply(this, arguments);
  };
}();